function init_girlnew_linn(from_php){
//    _moduleEvents.trigger("useFun",["test1",1,2,3]);
    var main=$(".place.girlnew");
    main.find(">.win").hide();
    function initOut(){
        var win=main.find(".out.win"),girl=win.find(".girlParts"),
        screen=win.find(".mainScreen"),
        car=win.find(".carWrap"),sayBox=win.find(".sayBox"),
        qAnim=win.find(".qAnim");
        win.show();
        girl.find(".eye").myEye();
        girl.find(".meye").myEye();
        qAnim.qAnim({width:200,loop:1,clips:15});
        var queueIndex=_moduleTimeHandler.getNewIndex(),queueIndexNext=_moduleTimeHandler.getNewIndex();
        var soundName;
        _moduleTimeHandler.queueAdd(queueIndex,function(){
            screen.css("right","0px");
            var howlong=3000;
            screen.animate({right:"-720px"},howlong);
            soundName=_mySound.playSound("girl_play");
            _moduleEvents.one("moduleClear",function(){
                _mySound.stopSound(soundName);
            });
            _moduleTimeHandler.setOne(queueIndexNext,function(){
                _moduleTimeHandler.queueTrigger(queueIndex);
            },howlong);
        });
        _moduleTimeHandler.queueAdd(queueIndex,function(){
            var howlong=3000;
            car.css("margin-left",'700px').addClass("show").animate({"margin-left":"0px"},howlong);
            _moduleTimeHandler.setOne(queueIndexNext,function(){
                _moduleTimeHandler.queueTrigger(queueIndex);
            },howlong);
        });
        _moduleTimeHandler.queueAdd(queueIndex,function(){
            
            sayBox.css({display:"block","opacity":0});
            _moduleEvents.trigger("useFun",["showWindowOut"]);      
            sayBox.animate({opacity:1},200);
            var num=0;
            sayBox.on("nextStep",function(){
                num++;
                if(num==2){
                    _mySound.stopSound(soundName);
                    _moduleTimeHandler.queueTrigger(queueIndex);
                }
            });
        });
        _moduleTimeHandler.queueAdd(queueIndex,function(){
            car.addClass("light");
            car.find(".light_up").qAnim({loop:1,clips:1,interval:1000});
            qAnim.hide();
            win.find(".girlParts").addClass("show");
            
        });
        _moduleTimeHandler.queueTrigger(queueIndex);
        
//        win.find(".qAnim").qAnim({width:200,loop:1,clips:15});
    }
    var addToLoader=[
        _IMG_SERV+"/gfx/place/girlnew/girls/linn/in/ready/carmask.png",
        _IMG_SERV+"/gfx/place/girlnew/girls/linn/in/ready/man.png",
        _IMG_SERV+"/gfx/place/girlnew/girls/linn/out/car/ready/car.png",
        _IMG_SERV+"/gfx/place/girlnew/girls/linn/out/car/ready/car_light.png",
        _IMG_SERV+"/gfx/place/girlnew/girls/linn/out/caught/girl.png"
    ];
    $.addToPlacePreloader(function(){
        initOut();
    },addToLoader);
    
    _moduleEvents.on("showWindow",function(mode){
        if(mode=="in"){
            var arr=[[0,0],[100,10],[200,0],[300,10],[400,0],[500,10],[600,0],[700,10]];
            var objSm=new Smooth(arr);
            var man=main.find("#manRunJS");
            var step=0,step_max=30,arr_len=arr.length-1;
            var indexA=_moduleTimeHandler.getNewIndex();
            _moduleTimeHandler.set(indexA,function(){
                step++;
                var pos=objSm(step/step_max*arr_len);
                man.css({"margin-left":pos[0]+"px","margin-top":pos[1]+"px"});
                
                if(step>=step_max){
                    _moduleTimeHandler.clear(indexA);
                }
            },50);
        }
    });
//    _moduleEvents.trigger("useFun",["showWindowIn"]);  
    
    
//    _moduleEvents.trigger("useFun",["showWindowOut"]);
}